module.exports = __webpack_public_path__ + "img/5.2c760125.jpeg";